import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "../index";
import {userLogoutReceived} from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  errors: [],
  readings: [],
  btuMeterReadings: [],
});

//is action payload immutable?
const usageReducer = handleActions(
  {
    [combineActions(Actions.fetchBTUMeterReadingsRequested, Actions.fetchMeterReadingsRequested)](state, action) {
      return state
        .set("isFetchingData", true);
    },
    [combineActions(Actions.fetchBTUMeterReadingsFailed, Actions.fetchMeterReadingsFailed)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", Immutable.fromJS(action.payload))
    },
    [Actions.fetchMeterReadingsReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("readings", Immutable.fromJS(action.payload))
    },
    [Actions.fetchBTUMeterReadingsReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("btuMeterReadings", Immutable.fromJS(action.payload))
    },
    [userLogoutReceived](state, action) {
      return initialState
    }
  },
  initialState
);

export { usageReducer };


// WEBPACK FOOTER //
// ./src/features/usage/store/usageReducer.js